<div class="upsell-why bg-white p-4">
  <div class="upsell-why__container max-w-container mx-auto">
    <div class="upsell-why__wrapper w-full flex flex-col desktop:flex-row items-center desktop:gap-x-8">
      <img class="w-full desktop:basis-2/5 desktop:flex-shrink-0" [src]="upsellWhyImage" alt="">
      <div class="upsell-why__questions desktop:basis-3/5 space-y-8">
        @for (item of upsellWhyContent; track $index) {
          <div class="upsell-why__item">
            <p class="upsell-why__question text-3xl font-bold mt-0 mb-4" [innerHTML]="item.question"></p>
            <div class="upsell-why__answer" [innerHTML]="item.answer"></div>
          </div>
        }
      </div>
    </div>
  </div>
</div>